import { useSpring } from "react-spring"

export function useDisplayAnimation(isDisplay: boolean, additionalStyle?: React.CSSProperties) {
  return useSpring({
    to: isDisplay
      ? [{ opacity: 1, display: "block", ...additionalStyle }]
      : [{ opacity: 0, ...additionalStyle }, { display: "none" }],
  })
}
